import React from 'react';
import styled from 'styled-components';
import Content from 'gatsby-theme-core/src/components/content';
import Container from 'gatsby-theme-core/src/components/container';
import Image from 'gatsby-theme-core/src/components/image';
import { transformOpeningHours } from 'gatsby-theme-core/src/hooks/use-opening-hours';
import OpeningHoursTable from 'gatsby-theme-pages/src/components/opening-hours-table';
import useFooter from '../../hooks/use-footer';
import Wrapper from './wrapper';
import Col from './col';
import Menu from './menu';
import Company from './company';
import Labels from './labels';
import Socialmedia from './socialmedia';
import Rating from './rating';
import SubFooter from '../sub-footer/index';

const Grid = styled.div`
  @media all and (min-width: ${({ theme }) => theme.breakingpoints.md}) {
    display: grid;
    grid-auto-rows: auto;
    grid-gap: ${({ theme }) => theme.grid.columnGap};
    grid-template-columns: 1fr 1fr;
  }

  @media all and (min-width: ${({ theme }) => theme.breakingpoints.lg}) {
    grid-template-columns: repeat(${({ $items }) => $items}, minmax(0, 1fr));
  }
`;

const CoreFooter = ({ className }) => {
  const footerItems = useFooter();
  return (
    <>
      <Wrapper className={className}>
        <Container>
          <Grid $items={footerItems.length}>
            {footerItems.map(({
              id,
              title,
              content,
              menu,
              labels,
              image,
              company,
              openingHours,
              socialmedia,
              rating,
            }) => (
              <Col key={id} title={title}>
                {content?.data?.childMarkdownRemark?.html && <Content $content={content} />}
                <Image image={image} />
                {menu && (<Menu {...menu} />)}
                {openingHours && (
                  <OpeningHoursTable
                    openingHours={transformOpeningHours(openingHours)}
                  />
                )}
                {company && (
                  <Company {...company} />
                )}
                {(labels || []).length > 0 && (
                  <Labels labels={labels} />
                )}
                {socialmedia && (
                  <Socialmedia {...socialmedia} />
                )}
                {rating && rating.length > 0 && (
                  <Rating ratingIds={rating.map(({ id: ratingId }) => ratingId)} {...rating} />
                )}
              </Col>
            ))}
          </Grid>
        </Container>
      </Wrapper>
      <SubFooter />
    </>
  );
};

export default styled(CoreFooter)``;
